export default __webpack_public_path__ + "static/media/4.5c0837f8.svg";